import { useEffect } from 'react';
import { SITE_URL } from '../data/seoPages';

const DEFAULT_TITLE = 'SG Cabs | Taxi Service in Bangalore – Airport Taxi, Outstation Cabs & One Way Drops';
const DEFAULT_DESC = 'Looking for a taxi near you in Bangalore? SG Cabs offers 24/7 airport taxi from ₹1350, outstation cabs at ₹14/km, one way drops to Hyderabad, Chennai, Mysuru, Goa & hourly rentals. Sedan & SUV. Call +91 75078 67648.';

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const [k, v] = selector.match(/\[(.+?)="(.+?)"\]/).slice(1);
    el.setAttribute(k, v);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const useSeo = ({ title, description, path, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('link[rel="canonical"]', 'href', `${SITE_URL}${path}`);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', `${SITE_URL}${path}`);

    let script;
    if (jsonLd) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-page-ld', 'true');
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    window.scrollTo(0, 0);

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', 'content', DEFAULT_DESC);
      setMeta('link[rel="canonical"]', 'href', `${SITE_URL}/`);
      setMeta('meta[property="og:title"]', 'content', DEFAULT_TITLE);
      setMeta('meta[property="og:description"]', 'content', DEFAULT_DESC);
      setMeta('meta[property="og:url"]', 'content', `${SITE_URL}/`);
      if (script) script.remove();
    };
  }, [title, description, path, jsonLd]);
};
